// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3ZpjU","colMin":"styles_colMin__398pa","colCheckbox":"styles_colCheckbox__1Oso1"};